import { getSearchParam } from '@/utils/helpers';

export type UTMParams = 'utm_campaign' | 'utm_content' | 'utm_medium' | 'utm_source' | 'utm_term';

export type UTMSearchParams = { [key in UTMParams]?: string };

export const getUtmSearchParams = (): UTMSearchParams => {
  const UtmQueryParams: UTMParams[] = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  return UtmQueryParams.reduce((acc, item) => {
    const value = getSearchParam(item);
    return value ? { ...acc, [item]: value } : acc;
  }, {});
};
